import { Component, Input } from '@angular/core';
import { People } from 'app/types';
import { DEFAULT_IDENTIFIER, getPersonIdentifier } from '../../../utils/people';

@Component({
  selector: 'side-panel-contributors',
  templateUrl: './side-panel-contributors.component.html',
  styleUrl: './side-panel-contributors.component.scss',
})
export class SidePanelContributorsComponent {
  @Input() creator?: People = undefined;
  @Input() contributors?: People[] = [];
  displayAllContributors: boolean = false;
  readonly MAX_CONTRIBUTORS_DISPLAYED = 3;
  protected readonly getPersonIdentifier = getPersonIdentifier;

  canDisplayMoreContributors(index: number): boolean {
    return (
      this.displayAllContributors || index < this.MAX_CONTRIBUTORS_DISPLAYED
    );
  }

  protected readonly DEFAULT_IDENTIFIER = DEFAULT_IDENTIFIER;
}
